/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description MediaType
 */

export enum MediaType {
  IMAGE = 1,
  LAYOUT = 2,
  VIDEO = 3,
  IFRAME = 4,
  LINK = 5,
  INTERNAL_VIDEO = 6,
}

Object.defineProperty(MediaType, '__ENUM_NAME', {
  value: 'MediaType',
  writable: false,
  configurable: false,
  enumerable: false,
})
